/**
 * Used for converting ISO to ibex country
 */
var countryMappings = [
    {
        "ibexCode": 109,
        "CountryName": "Australia",
        "CountryCode": "AU"
    },
    {
        "ibexCode": 110,
        "CountryName": "Canada",
        "CountryCode": "CA"
    },
    {
        "ibexCode": 112,
        "CountryName": "Germany",
        "CountryCode": "DE"
    },
    {
        "ibexCode": 113,
        "CountryName": "Japan",
        "CountryCode": "JP"
    },
    {
        "ibexCode": 108,
        "CountryName": "New Zealand",
        "CountryCode": "NZ"
    },
    {
        "ibexCode": 111,
        "CountryName": "United Kingdom",
        "CountryCode": "GB"
    },
    {
        "ibexCode": 114,
        "CountryName": "United States of America",
        "CountryCode": "US"
    },
    {
        "ibexCode": 508,
        "CountryName": "Aland Islands",
        "CountryCode": "AF"
    },
    {
        "ibexCode": 62,
        "CountryName": "Albania",
        "CountryCode": "AL"
    },
    {
        "ibexCode": 61,
        "CountryName": "Algeria",
        "CountryCode": "DZ"
    },
    {
        "ibexCode": 152,
        "CountryName": "American Samoa",
        "CountryCode": "AS"
    },
    {
        "ibexCode": 509,
        "CountryName": "Andorra",
        "CountryCode": "AD"
    },
    {
        "ibexCode": 510,
        "CountryName": "Angola",
        "CountryCode": "AO"
    },
    {
        "ibexCode": 511,
        "CountryName": "Anguilla",
        "CountryCode": "AI"
    },
    {
        "ibexCode": 512,
        "CountryName": "Antarctica",
        "CountryCode": "AQ"
    },
    {
        "ibexCode": 118,
        "CountryName": "Antigua",
        "CountryCode": "AG"
    },
    {
        "ibexCode": 513,
        "CountryName": "Antigua and Barbuda",
        "CountryCode": "AG"
    },
    {
        "ibexCode": 107,
        "CountryName": "Argentina",
        "CountryCode": "AR"
    },
    {
        "ibexCode": 514,
        "CountryName": "Armenia",
        "CountryCode": "AM"
    },
    {
        "ibexCode": 515,
        "CountryName": "Aruba",
        "CountryCode": "AW"
    },
    {
        "ibexCode": 87,
        "CountryName": "Austria",
        "CountryCode": "AT"
    },
    {
        "ibexCode": 516,
        "CountryName": "Azerbaijan",
        "CountryCode": "AZ"
    },
    {
        "ibexCode": 517,
        "CountryName": "Bahamas",
        "CountryCode": "BS"
    },
    {
        "ibexCode": 115,
        "CountryName": "Bahrain",
        "CountryCode": "BH"
    },
    {
        "ibexCode": 518,
        "CountryName": "Bangladesh",
        "CountryCode": "BD"
    },
    {
        "ibexCode": 119,
        "CountryName": "Barbados",
        "CountryCode": "BB"
    },
    {
        "ibexCode": 120,
        "CountryName": "Belarus",
        "CountryCode": "BY"
    },
    {
        "ibexCode": 89,
        "CountryName": "Belgium",
        "CountryCode": "BE"
    },
    {
        "ibexCode": 519,
        "CountryName": "Belize",
        "CountryCode": "BZ"
    },
    {
        "ibexCode": 520,
        "CountryName": "Benin",
        "CountryCode": "BJ"
    },
    {
        "ibexCode": 153,
        "CountryName": "Bermuda",
        "CountryCode": "BM"
    },
    {
        "ibexCode": 521,
        "CountryName": "Bhutan",
        "CountryCode": "BT"
    },
    {
        "ibexCode": 121,
        "CountryName": "Bolivia",
        "CountryCode": "BO"
    },
    {
        "ibexCode": 522,
        "CountryName": "Bonaire, Sint Eustatius and Saba",
        "CountryCode": "BQ"
    },
    {
        "ibexCode": 122,
        "CountryName": "Bosnia and Herzegovina",
        "CountryCode": "BA"
    },
    {
        "ibexCode": 123,
        "CountryName": "Botswana",
        "CountryCode": "BW"
    },
    {
        "ibexCode": 523,
        "CountryName": "Bouvet Island",
        "CountryCode": "BV"
    },
    {
        "ibexCode": 60,
        "CountryName": "Brazil",
        "CountryCode": "BR"
    },
    {
        "ibexCode": 524,
        "CountryName": "British Indian Ocean Territory",
        "CountryCode": "IO"
    },
    {
        "ibexCode": 59,
        "CountryName": "Brunei",
        "CountryCode": "BN"
    },
    {
        "ibexCode": 124,
        "CountryName": "Bulgaria",
        "CountryCode": "BG"
    },
    {
        "ibexCode": 525,
        "CountryName": "Burkina Faso",
        "CountryCode": "BF"
    },
    {
        "ibexCode": 526,
        "CountryName": "Burundi",
        "CountryCode": "BI"
    },
    {
        "ibexCode": 527,
        "CountryName": "Cabo Verde",
        "CountryCode": "CV"
    },
    {
        "ibexCode": 100,
        "CountryName": "Cambodia",
        "CountryCode": "KH"
    },
    {
        "ibexCode": 528,
        "CountryName": "Cameroon",
        "CountryCode": "CM"
    },
    {
        "ibexCode": 529,
        "CountryName": "Cayman Islands",
        "CountryCode": "KY"
    },
    {
        "ibexCode": 530,
        "CountryName": "Central African Republic",
        "CountryCode": "CF"
    },
    {
        "ibexCode": 531,
        "CountryName": "Chad",
        "CountryCode": "TD"
    },
    {
        "ibexCode": 58,
        "CountryName": "Chile",
        "CountryCode": "CL"
    },
    {
        "ibexCode": 98,
        "CountryName": "China",
        "CountryCode": "CN"
    },
    {
        "ibexCode": 532,
        "CountryName": "Christmas Island",
        "CountryCode": "CX"
    },
    {
        "ibexCode": 533,
        "CountryName": "Cocos (Keeling) Islands",
        "CountryCode": "CC"
    },
    {
        "ibexCode": 57,
        "CountryName": "Colombia",
        "CountryCode": "CO"
    },
    {
        "ibexCode": 534,
        "CountryName": "Comoros",
        "CountryCode": "KM"
    },
    {
        "ibexCode": 535,
        "CountryName": "Congo (the Democratic Republic of the)",
        "CountryCode": "CD"
    },
    {
        "ibexCode": 536,
        "CountryName": "Congo (the)",
        "CountryCode": "CG"
    },
    {
        "ibexCode": 56,
        "CountryName": "Cook Islands",
        "CountryCode": "CK"
    },
    {
        "ibexCode": 106,
        "CountryName": "Costa Rica",
        "CountryCode": "CR"
    },
    {
        "ibexCode": 90,
        "CountryName": "Croatia",
        "CountryCode": "HR"
    },
    {
        "ibexCode": 55,
        "CountryName": "Cuba",
        "CountryCode": "CU"
    },
    {
        "ibexCode": 538,
        "CountryName": "Curaçao",
        "CountryCode": "CW"
    },
    {
        "ibexCode": 54,
        "CountryName": "Cyprus",
        "CountryCode": "CY"
    },
    {
        "ibexCode": 86,
        "CountryName": "Czech Republic",
        "CountryCode": "CZ"
    },
    {
        "ibexCode": 537,
        "CountryName": "Côte d'Ivoire",
        "CountryCode": "CI"
    },
    {
        "ibexCode": 85,
        "CountryName": "Denmark",
        "CountryCode": "DK"
    },
    {
        "ibexCode": 505,
        "CountryName": "Djibouti",
        "CountryCode": "DJ"
    },
    {
        "ibexCode": 539,
        "CountryName": "Dominica",
        "CountryCode": "DM"
    },
    {
        "ibexCode": 125,
        "CountryName": "Dominican Republic",
        "CountryCode": "DO"
    },
    {
        "ibexCode": 126,
        "CountryName": "Ecuador",
        "CountryCode": "EC"
    },
    {
        "ibexCode": 53,
        "CountryName": "Egypt",
        "CountryCode": "EG"
    },
    {
        "ibexCode": 52,
        "CountryName": "El Salvador",
        "CountryCode": "SV"
    },
    {
        "ibexCode": 540,
        "CountryName": "Equatorial Guinea",
        "CountryCode": "GQ"
    },
    {
        "ibexCode": 541,
        "CountryName": "Eritrea",
        "CountryCode": "ER"
    },
    {
        "ibexCode": 127,
        "CountryName": "Estonia",
        "CountryCode": "EE"
    },
    {
        "ibexCode": 105,
        "CountryName": "Ethiopia",
        "CountryCode": "ET"
    },
    {
        "ibexCode": 542,
        "CountryName": "Falkland Islands",
        "CountryCode": "FK"
    },
    {
        "ibexCode": 543,
        "CountryName": "Faroe Islands",
        "CountryCode": "FO"
    },
    {
        "ibexCode": 51,
        "CountryName": "Fiji",
        "CountryCode": "FJ"
    },
    {
        "ibexCode": 84,
        "CountryName": "Finland",
        "CountryCode": "FI"
    },
    {
        "ibexCode": 83,
        "CountryName": "France",
        "CountryCode": "FR"
    },
    {
        "ibexCode": 544,
        "CountryName": "French Guiana",
        "CountryCode": "GF"
    },
    {
        "ibexCode": 50,
        "CountryName": "French Polynesia",
        "CountryCode": "PF"
    },
    {
        "ibexCode": 545,
        "CountryName": "French Southern Territories",
        "CountryCode": "TF"
    },
    {
        "ibexCode": 546,
        "CountryName": "Gabon",
        "CountryCode": "GA"
    },
    {
        "ibexCode": 547,
        "CountryName": "Gambia",
        "CountryCode": "GM"
    },
    {
        "ibexCode": 49,
        "CountryName": "Georgia",
        "CountryCode": "GE"
    },
    {
        "ibexCode": 151,
        "CountryName": "Ghana",
        "CountryCode": "GH"
    },
    {
        "ibexCode": 48,
        "CountryName": "Gibraltar",
        "CountryCode": "GI"
    },
    {
        "ibexCode": 47,
        "CountryName": "Greece",
        "CountryCode": "GR"
    },
    {
        "ibexCode": 104,
        "CountryName": "Greenland",
        "CountryCode": "GL"
    },
    {
        "ibexCode": 128,
        "CountryName": "Grenada",
        "CountryCode": "GD"
    },
    {
        "ibexCode": 129,
        "CountryName": "Guadeloupe",
        "CountryCode": "GP"
    },
    {
        "ibexCode": 130,
        "CountryName": "Guam",
        "CountryCode": "GU"
    },
    {
        "ibexCode": 131,
        "CountryName": "Guatemala",
        "CountryCode": "GT"
    },
    {
        "ibexCode": 548,
        "CountryName": "Guernsey",
        "CountryCode": "GG"
    },
    {
        "ibexCode": 549,
        "CountryName": "Guinea",
        "CountryCode": "GN"
    },
    {
        "ibexCode": 550,
        "CountryName": "Guinea-Bissau",
        "CountryCode": "GW"
    },
    {
        "ibexCode": 46,
        "CountryName": "Guyana",
        "CountryCode": "GY"
    },
    {
        "ibexCode": 103,
        "CountryName": "Haiti",
        "CountryCode": "HT"
    },
    {
        "ibexCode": 551,
        "CountryName": "Heard Island and McDonald Islands",
        "CountryCode": "HM"
    },
    {
        "ibexCode": 552,
        "CountryName": "Holy See",
        "CountryCode": "VA"
    },
    {
        "ibexCode": 45,
        "CountryName": "Honduras",
        "CountryCode": "HN"
    },
    {
        "ibexCode": 44,
        "CountryName": "Hong Kong",
        "CountryCode": "HK"
    },
    {
        "ibexCode": 82,
        "CountryName": "Hungary",
        "CountryCode": "HU"
    },
    {
        "ibexCode": 43,
        "CountryName": "Iceland",
        "CountryCode": "IS"
    },
    {
        "ibexCode": 42,
        "CountryName": "India",
        "CountryCode": "IN"
    },
    {
        "ibexCode": 97,
        "CountryName": "Indonesia",
        "CountryCode": "ID"
    },
    {
        "ibexCode": 41,
        "CountryName": "Iran",
        "CountryCode": "IR"
    },
    {
        "ibexCode": 40,
        "CountryName": "Iraq",
        "CountryCode": "IQ"
    },
    {
        "ibexCode": 68,
        "CountryName": "Ireland",
        "CountryCode": "IE"
    },
    {
        "ibexCode": 553,
        "CountryName": "Isle of Man",
        "CountryCode": "IM"
    },
    {
        "ibexCode": 39,
        "CountryName": "Israel",
        "CountryCode": "IL"
    },
    {
        "ibexCode": 81,
        "CountryName": "Italy",
        "CountryCode": "IT"
    },
    {
        "ibexCode": 38,
        "CountryName": "Jamaica",
        "CountryCode": "JM"
    },
    {
        "ibexCode": 554,
        "CountryName": "Jersey",
        "CountryCode": "JE"
    },
    {
        "ibexCode": 37,
        "CountryName": "Jordan",
        "CountryCode": "JO"
    },
    {
        "ibexCode": 555,
        "CountryName": "Kazakhstan",
        "CountryCode": "KZ"
    },
    {
        "ibexCode": 36,
        "CountryName": "Kenya",
        "CountryCode": "KE"
    },
    {
        "ibexCode": 556,
        "CountryName": "Kiribati",
        "CountryCode": "KI"
    },
    {
        "ibexCode": 35,
        "CountryName": "Kuwait",
        "CountryCode": "KW"
    },
    {
        "ibexCode": 557,
        "CountryName": "Kyrgyzstan",
        "CountryCode": "KG"
    },
    {
        "ibexCode": 96,
        "CountryName": "Laos",
        "CountryCode": "LA"
    },
    {
        "ibexCode": 132,
        "CountryName": "Latvia",
        "CountryCode": "LV"
    },
    {
        "ibexCode": 34,
        "CountryName": "Lebanon",
        "CountryCode": "LB"
    },
    {
        "ibexCode": 558,
        "CountryName": "Lesotho",
        "CountryCode": "LS"
    },
    {
        "ibexCode": 33,
        "CountryName": "Liberia",
        "CountryCode": "LR"
    },
    {
        "ibexCode": 32,
        "CountryName": "Libya",
        "CountryCode": "LY"
    },
    {
        "ibexCode": 559,
        "CountryName": "Liechtenstein",
        "CountryCode": "LI"
    },
    {
        "ibexCode": 31,
        "CountryName": "Lithuania",
        "CountryCode": "LT"
    },
    {
        "ibexCode": 88,
        "CountryName": "Luxembourg",
        "CountryCode": "LU"
    },
    {
        "ibexCode": 133,
        "CountryName": "Macau",
        "CountryCode": "MO"
    },
    {
        "ibexCode": 80,
        "CountryName": "Macedonia",
        "CountryCode": "MK"
    },
    {
        "ibexCode": 560,
        "CountryName": "Madagascar",
        "CountryCode": "MG"
    },
    {
        "ibexCode": 561,
        "CountryName": "Malawi",
        "CountryCode": "MW"
    },
    {
        "ibexCode": 95,
        "CountryName": "Malaysia",
        "CountryCode": "MY"
    },
    {
        "ibexCode": 154,
        "CountryName": "Maldives",
        "CountryCode": "MV"
    },
    {
        "ibexCode": 562,
        "CountryName": "Mali",
        "CountryCode": "ML"
    },
    {
        "ibexCode": 134,
        "CountryName": "Malta",
        "CountryCode": "MT"
    },
    {
        "ibexCode": 563,
        "CountryName": "Marshall Islands",
        "CountryCode": "MH"
    },
    {
        "ibexCode": 564,
        "CountryName": "Martinique",
        "CountryCode": "MQ"
    },
    {
        "ibexCode": 565,
        "CountryName": "Mauritania",
        "CountryCode": "MR"
    },
    {
        "ibexCode": 117,
        "CountryName": "Mauritius",
        "CountryCode": "MU"
    },
    {
        "ibexCode": 566,
        "CountryName": "Mayotte",
        "CountryCode": "YT"
    },
    {
        "ibexCode": 30,
        "CountryName": "Mexico",
        "CountryCode": "MX"
    },
    {
        "ibexCode": 135,
        "CountryName": "Micronesia",
        "CountryCode": "FM"
    },
    {
        "ibexCode": 567,
        "CountryName": "Moldova",
        "CountryCode": "MD"
    },
    {
        "ibexCode": 568,
        "CountryName": "Monaco",
        "CountryCode": "MC"
    },
    {
        "ibexCode": 569,
        "CountryName": "Mongolia",
        "CountryCode": "MN"
    },
    {
        "ibexCode": 570,
        "CountryName": "Montenegro",
        "CountryCode": "ME"
    },
    {
        "ibexCode": 571,
        "CountryName": "Montserrat",
        "CountryCode": "MS"
    },
    {
        "ibexCode": 29,
        "CountryName": "Morocco",
        "CountryCode": "MA"
    },
    {
        "ibexCode": 572,
        "CountryName": "Mozambique",
        "CountryCode": "MZ"
    },
    {
        "ibexCode": 136,
        "CountryName": "Myanmar",
        "CountryCode": "MM"
    },
    {
        "ibexCode": 137,
        "CountryName": "Namibia",
        "CountryCode": "NA"
    },
    {
        "ibexCode": 573,
        "CountryName": "Nauru",
        "CountryCode": "NR"
    },
    {
        "ibexCode": 574,
        "CountryName": "Nepal",
        "CountryCode": "NP"
    },
    {
        "ibexCode": 79,
        "CountryName": "Netherlands",
        "CountryCode": "NL"
    },
    {
        "ibexCode": 102,
        "CountryName": "New Caledonia",
        "CountryCode": "NC"
    },
    {
        "ibexCode": 28,
        "CountryName": "Nicaragua",
        "CountryCode": "NI"
    },
    {
        "ibexCode": 575,
        "CountryName": "Niger",
        "CountryCode": "NE"
    },
    {
        "ibexCode": 27,
        "CountryName": "Nigeria",
        "CountryCode": "NG"
    },
    {
        "ibexCode": 149,
        "CountryName": "Niue",
        "CountryCode": "NU"
    },
    {
        "ibexCode": 457,
        "CountryName": "Norfolk Island",
        "CountryCode": "NF"
    },
    {
        "ibexCode": 64,
        "CountryName": "North Korea",
        "CountryCode": "KP"
    },
    {
        "ibexCode": 576,
        "CountryName": "Northern Mariana Islands",
        "CountryCode": "MP"
    },
    {
        "ibexCode": 78,
        "CountryName": "Norway",
        "CountryCode": "NO"
    },
    {
        "ibexCode": 116,
        "CountryName": "Oman",
        "CountryCode": "OM"
    },
    {
        "ibexCode": 63,
        "CountryName": "Other",
        "CountryCode": ""
    },
    {
        "ibexCode": 25,
        "CountryName": "Pakistan",
        "CountryCode": "PK"
    },
    {
        "ibexCode": 138,
        "CountryName": "Palau",
        "CountryCode": "PW"
    },
    {
        "ibexCode": 577,
        "CountryName": "Palestine",
        "CountryCode": "PS"
    },
    {
        "ibexCode": 24,
        "CountryName": "Panama",
        "CountryCode": "PA"
    },
    {
        "ibexCode": 23,
        "CountryName": "Papua New Guinea",
        "CountryCode": "PG"
    },
    {
        "ibexCode": 22,
        "CountryName": "Paraguay",
        "CountryCode": "PY"
    },
    {
        "ibexCode": 21,
        "CountryName": "Peru",
        "CountryCode": "PE"
    },
    {
        "ibexCode": 94,
        "CountryName": "Philippines",
        "CountryCode": "PH"
    },
    {
        "ibexCode": 578,
        "CountryName": "Pitcairn",
        "CountryCode": "PN"
    },
    {
        "ibexCode": 77,
        "CountryName": "Poland",
        "CountryCode": "PL"
    },
    {
        "ibexCode": 20,
        "CountryName": "Portugal",
        "CountryCode": "PT"
    },
    {
        "ibexCode": 19,
        "CountryName": "Puerto Rico",
        "CountryCode": "PR"
    },
    {
        "ibexCode": 139,
        "CountryName": "Qatar",
        "CountryCode": "QA"
    },
    {
        "ibexCode": 76,
        "CountryName": "Romania",
        "CountryCode": "RO"
    },
    {
        "ibexCode": 75,
        "CountryName": "Russia",
        "CountryCode": "RU"
    },
    {
        "ibexCode": 101,
        "CountryName": "Rwanda",
        "CountryCode": "RW"
    },
    {
        "ibexCode": 579,
        "CountryName": "Réunion",
        "CountryCode": "RE"
    },
    {
        "ibexCode": 580,
        "CountryName": "Saint Barthélemy",
        "CountryCode": "BL"
    },
    {
        "ibexCode": 581,
        "CountryName": "Saint Helena, Ascension and Tristan da Cunha",
        "CountryCode": "SH"
    },
    {
        "ibexCode": 582,
        "CountryName": "Saint Kitts and Nevis",
        "CountryCode": "KN"
    },
    {
        "ibexCode": 144,
        "CountryName": "Saint Lucia",
        "CountryCode": "LC"
    },
    {
        "ibexCode": 583,
        "CountryName": "Saint Martin",
        "CountryCode": "MF"
    },
    {
        "ibexCode": 584,
        "CountryName": "Saint Pierre and Miquelon",
        "CountryCode": "PM"
    },
    {
        "ibexCode": 585,
        "CountryName": "Saint Vincent and the Grenadines",
        "CountryCode": "VC"
    },
    {
        "ibexCode": 18,
        "CountryName": "Samoa",
        "CountryCode": "WS"
    },
    {
        "ibexCode": 586,
        "CountryName": "San Marino",
        "CountryCode": "SM"
    },
    {
        "ibexCode": 587,
        "CountryName": "Sao Tome and Principe",
        "CountryCode": "ST"
    },
    {
        "ibexCode": 17,
        "CountryName": "Saudi Arabia",
        "CountryCode": "SA"
    },
    {
        "ibexCode": 588,
        "CountryName": "Senegal",
        "CountryCode": "SN"
    },
    {
        "ibexCode": 140,
        "CountryName": "Serbia",
        "CountryCode": "RS"
    },
    {
        "ibexCode": 141,
        "CountryName": "Seychelles",
        "CountryCode": "SC"
    },
    {
        "ibexCode": 589,
        "CountryName": "Sierra Leone",
        "CountryCode": "SL"
    },
    {
        "ibexCode": 93,
        "CountryName": "Singapore",
        "CountryCode": "SG"
    },
    {
        "ibexCode": 590,
        "CountryName": "Sint Maarten",
        "CountryCode": "SX"
    },
    {
        "ibexCode": 142,
        "CountryName": "Slovakia",
        "CountryCode": "SK"
    },
    {
        "ibexCode": 143,
        "CountryName": "Slovenia",
        "CountryCode": "SI"
    },
    {
        "ibexCode": 16,
        "CountryName": "Solomon Islands",
        "CountryCode": "SB"
    },
    {
        "ibexCode": 591,
        "CountryName": "Somalia",
        "CountryCode": "SO"
    },
    {
        "ibexCode": 15,
        "CountryName": "South Africa",
        "CountryCode": "ZA"
    },
    {
        "ibexCode": 592,
        "CountryName": "South Georgia and the South Sandwich Islands",
        "CountryCode": "GS"
    },
    {
        "ibexCode": 65,
        "CountryName": "South Korea",
        "CountryCode": "KR"
    },
    {
        "ibexCode": 593,
        "CountryName": "South Sudan",
        "CountryCode": "SS"
    },
    {
        "ibexCode": 74,
        "CountryName": "Spain",
        "CountryCode": "ES"
    },
    {
        "ibexCode": 14,
        "CountryName": "Sri Lanka",
        "CountryCode": "LK"
    },
    {
        "ibexCode": 594,
        "CountryName": "Sudan",
        "CountryCode": "SD"
    },
    {
        "ibexCode": 595,
        "CountryName": "Suriname",
        "CountryCode": "SR"
    },
    {
        "ibexCode": 596,
        "CountryName": "Svalbard and Jan Mayen",
        "CountryCode": "SJ"
    },
    {
        "ibexCode": 597,
        "CountryName": "Swaziland",
        "CountryCode": "SZ"
    },
    {
        "ibexCode": 73,
        "CountryName": "Sweden",
        "CountryCode": "SE"
    },
    {
        "ibexCode": 72,
        "CountryName": "Switzerland",
        "CountryCode": "CH"
    },
    {
        "ibexCode": 13,
        "CountryName": "Syria",
        "CountryCode": "SY"
    },
    {
        "ibexCode": 92,
        "CountryName": "Taiwan",
        "CountryCode": "TW"
    },
    {
        "ibexCode": 598,
        "CountryName": "Tajikistan",
        "CountryCode": "TJ"
    },
    {
        "ibexCode": 145,
        "CountryName": "Tanzania",
        "CountryCode": "TZ"
    },
    {
        "ibexCode": 99,
        "CountryName": "Thailand",
        "CountryCode": "TH"
    },
    {
        "ibexCode": 599,
        "CountryName": "Timor-Leste",
        "CountryCode": "TL"
    },
    {
        "ibexCode": 600,
        "CountryName": "Togo",
        "CountryCode": "TG"
    },
    {
        "ibexCode": 601,
        "CountryName": "Tokelau",
        "CountryCode": "TK"
    },
    {
        "ibexCode": 12,
        "CountryName": "Tonga",
        "CountryCode": "TO"
    },
    {
        "ibexCode": 146,
        "CountryName": "Trinidad and Tobago",
        "CountryCode": "TT"
    },
    {
        "ibexCode": 147,
        "CountryName": "Tunisia",
        "CountryCode": "TN"
    },
    {
        "ibexCode": 71,
        "CountryName": "Turkey",
        "CountryCode": "TR"
    },
    {
        "ibexCode": 602,
        "CountryName": "Turkmenistan",
        "CountryCode": "TM"
    },
    {
        "ibexCode": 603,
        "CountryName": "Turks and Caicos Islands",
        "CountryCode": "TC"
    },
    {
        "ibexCode": 604,
        "CountryName": "Tuvalu",
        "CountryCode": "TV"
    },
    {
        "ibexCode": 605,
        "CountryName": "Uganda",
        "CountryCode": "UG"
    },
    {
        "ibexCode": 11,
        "CountryName": "Uganda",
        "CountryCode": "UG"
    },
    {
        "ibexCode": 70,
        "CountryName": "Ukraine",
        "CountryCode": "UA"
    },
    {
        "ibexCode": 10,
        "CountryName": "United Arab Emirates",
        "CountryCode": "AE"
    },
    {
        "ibexCode": 606,
        "CountryName": "United States Minor Outlying Islands",
        "CountryCode": "UM"
    },
    {
        "ibexCode": 9,
        "CountryName": "Uruguay",
        "CountryCode": "UY"
    },
    {
        "ibexCode": 607,
        "CountryName": "Uzbekistan",
        "CountryCode": "UZ"
    },
    {
        "ibexCode": 8,
        "CountryName": "Vanuatu",
        "CountryCode": "VU"
    },
    {
        "ibexCode": 7,
        "CountryName": "Venezuela",
        "CountryCode": "VE"
    },
    {
        "ibexCode": 91,
        "CountryName": "Vietnam",
        "CountryCode": "VN"
    },
    {
        "ibexCode": 608,
        "CountryName": "Virgin Islands (British)",
        "CountryCode": "VG"
    },
    {
        "ibexCode": 609,
        "CountryName": "Virgin Islands (U.S.)",
        "CountryCode": "VI"
    },
    {
        "ibexCode": 610,
        "CountryName": "Wallis and Futuna",
        "CountryCode": "WF"
    },
    {
        "ibexCode": 611,
        "CountryName": "Western Sahara",
        "CountryCode": "EH"
    },
    {
        "ibexCode": 148,
        "CountryName": "Yemen",
        "CountryCode": "YE"
    },
    {
        "ibexCode": 6,
        "CountryName": "Zambia",
        "CountryCode": "ZM"
    },
    {
        "ibexCode": 5,
        "CountryName": "Zimbabwe",
        "CountryCode": "ZW"
    }
];

var countryMapper = {
	getIbexCodeFromCountryCode: function(countryCode){
		foundCode = 63; // default to other for countries not found
		for(var code in countryMappings){
			if(countryMappings.hasOwnProperty(code)){
				if(countryMappings[code].CountryCode.toUpperCase() === countryCode.toUpperCase()){
					foundCode = countryMappings[code].ibexCode;
				}
			}
		}
		return foundCode;
	},
	getCountryNameFromCountryCode: function(countryCode){
		foundCountry = "Other"; // default to other for countries not found
		for(var code in countryMappings){
			if(countryMappings.hasOwnProperty(code)){
				if(countryMappings[code].CountryCode.toUpperCase() === countryCode.toUpperCase()){
					foundCountry = countryMappings[code].CountryName;
				}
			}
		}
		return foundCountry;
	}
};
